import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function IconRender({ node }) {
  const content = node.content || {};
  const iconName = content.icon || '🚀';
  const size = content.size || '32px';
  const color = content.color || '#00A9E0';
  const align = content.align || 'center';

  return (
    <div style={{ display: 'flex', justifyContent: align, width: '100%' }}>
      <span style={{ fontSize: size, color: color, lineHeight: 1 }}>{iconName}</span>
    </div>
  );
}

registry.register('Icon', {
  label: 'Icon',
  icon: '⭐', 
  category: 'basic',
  component: IconRender,
  
  defaultProps: {
    content: {
      icon: '🚀',
      size: '32px',
      color: '#00A9E0',
      align: 'center'
    },
    style: {
      desktop: {
        padding: '10px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Icon Einstellungen',
          fields: [
            { name: 'content.icon', label: 'Icon (Emoji oder Text)', type: 'text' },
            { name: 'content.size', label: 'Größe (z.B. 32px, 4rem)', type: 'text' },
            { name: 'content.color', label: 'Farbe', type: 'color' },
            { name: 'content.align', label: 'Ausrichtung', type: 'select', options: ['flex-start', 'center', 'flex-end'] }
          ]
        }
      ]
    }
  ]
});
